/*
 * Authors: mariushirjanu
 * Created: 16/06/2020
 * Upgraded: 07/03/2023
 */
import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';

@Injectable()
export class CatalogStateService {
  private _baseParams:IObject;
  private _overviewState:string;
  private _detailState:string;
  private _buyingGuideId:number;
  private _allowMasterStockOrders:boolean;

  constructor() {
    /***/
  }

  public createStateParams(params?:IObject):IObject {
    return _.extend(params, this._baseParams);
  }

  public get baseParams():IObject {
    return this._baseParams;
  }
  public set baseParams(baseParams:IObject) {
    this._baseParams = baseParams;
  }

  public get overviewState():string {
    return this._overviewState;
  }
  public set overviewState(overviewState:string) {
    this._overviewState = overviewState;
  }

  public get detailState():string {
    return this._detailState;
  }
  public set detailState(detailState:string) {
    this._detailState = detailState;
  }

  public get buyingGuideId():number {
    return this._buyingGuideId;
  }
  public set buyingGuideId(buyingGuideId:number) {
    this._buyingGuideId = buyingGuideId;
  }

  public get allowMasterStockOrders():boolean {
    return this._allowMasterStockOrders;
  }
  public set allowMasterStockOrders(allowMasterStockOrders:boolean) {
    this._allowMasterStockOrders = allowMasterStockOrders;
  }

  public clear():void {
    this._overviewState = undefined;
    this._detailState = undefined;
    this._baseParams = undefined;
    this._buyingGuideId = undefined;
  }
}